// AUTO-GENERATED from nlreferences nl_2012_wgt_{sex}_{ga}.txt
// Source: Bocca-Tjeertes IFA, van Buuren S, et al. (2012) J Pediatr 161:460.
// Preterm weight-for-age LMS, gestational age 25-36 weeks, both sexes,
// trimmed to age ≤ 1.5 yr. Used by NL5 wgt advice when baby.ga_days < 259.
import type { LMSRow } from './lms.ts';

export const PRETERM_WGT: Record<'M' | 'F', Record<number, LMSRow[]>> = {
  M: {
    25: [
      { age_yr: 0, L: 1.0885, M: 0.962, S: 0.2111 },
      { age_yr: 0.0027, L: 1.0836, M: 0.944, S: 0.2119 },
      { age_yr: 0.0055, L: 1.0785, M: 0.927, S: 0.2126 },
      { age_yr: 0.0082, L: 1.0737, M: 0.913, S: 0.2133 },
      { age_yr: 0.011, L: 1.0688, M: 0.901, S: 0.214 },
      { age_yr: 0.0137, L: 1.0642, M: 0.891, S: 0.2146 },
      { age_yr: 0.0164, L: 1.0596, M: 0.883, S: 0.2153 },
      { age_yr: 0.0192, L: 1.0549, M: 0.876, S: 0.2159 },
      { age_yr: 0.0219, L: 1.0504, M: 0.871, S: 0.2165 },
      { age_yr: 0.0246, L: 1.046, M: 0.868, S: 0.217 },
      { age_yr: 0.0274, L: 1.0416, M: 0.866, S: 0.2176 },
      { age_yr: 0.0301, L: 1.0373000000000001, M: 0.866, S: 0.2181 },
      { age_yr: 0.0329, L: 1.0329, M: 0.867, S: 0.2186 },
      { age_yr: 0.0356, L: 1.0288, M: 0.869, S: 0.2191 },
      { age_yr: 0.0383, L: 1.0247, M: 0.873, S: 0.2195 },
      { age_yr: 0.0575, L: 0.997, M: 0.932, S: 0.2223 },
      { age_yr: 0.0958, L: 0.9485, M: 1.172, S: 0.2256 },
      { age_yr: 0.1342, L: 0.9068, M: 1.507, S: 0.2268 },
      { age_yr: 0.1725, L: 0.8705, M: 1.886, S: 0.2266 },
      { age_yr: 0.2108, L: 0.8384, M: 2.283, S: 0.2254 },
      { age_yr: 0.2491, L: 0.8097, M: 2.683, S: 0.2236 },
      { age_yr: 0.2917, L: 0.7809, M: 3.121, S: 0.2213 },
      { age_yr: 0.375, L: 0.732, M: 3.935, S: 0.2162 },
      { age_yr: 0.4583, L: 0.6902, M: 4.676, S: 0.2112 },
      { age_yr: 0.5417, L: 0.6532, M: 5.34, S: 0.2066 },
      { age_yr: 0.625, L: 0.6197, M: 5.931, S: 0.2025 },
      { age_yr: 0.7083, L: 0.5887, M: 6.46, S: 0.199 },
      { age_yr: 0.7917, L: 0.5597, M: 6.937, S: 0.1959 },
      { age_yr: 0.875, L: 0.5321, M: 7.368, S: 0.1933 },
      { age_yr: 0.9583, L: 0.5057, M: 7.763, S: 0.191 },
      { age_yr: 1.0833, L: 0.4679, M: 8.298, S: 0.188 },
      { age_yr: 1.25, L: 0.4201, M: 8.933, S: 0.1849 },
      { age_yr: 1.4167, L: 0.3746, M: 9.5, S: 0.1823 },
    ],
    26: [
      { age_yr: 0, L: 1.0885, M: 0.985, S: 0.2061 },
      { age_yr: 0.0027, L: 1.0836, M: 0.971, S: 0.2065 },
      { age_yr: 0.0055, L: 1.0785, M: 0.96, S: 0.207 },
      { age_yr: 0.0082, L: 1.0737, M: 0.95, S: 0.2074 },
      { age_yr: 0.011, L: 1.0688, M: 0.943, S: 0.2078 },
      { age_yr: 0.0137, L: 1.0642, M: 0.937, S: 0.2081 },
      { age_yr: 0.0164, L: 1.0596, M: 0.933, S: 0.2085 },
      { age_yr: 0.0192, L: 1.0549, M: 0.93, S: 0.2088 },
      { age_yr: 0.0219, L: 1.0504, M: 0.929, S: 0.2091 },
      { age_yr: 0.0246, L: 1.046, M: 0.93, S: 0.2094 },
      { age_yr: 0.0274, L: 1.0416, M: 0.932, S: 0.2097 },
      { age_yr: 0.0301, L: 1.0373000000000001, M: 0.936, S: 0.2099 },
      { age_yr: 0.0329, L: 1.0329, M: 0.941, S: 0.2102 },
      { age_yr: 0.0356, L: 1.0288, M: 0.947, S: 0.2104 },
      { age_yr: 0.0383, L: 1.0247, M: 0.954, S: 0.2106 },
      { age_yr: 0.0575, L: 0.997, M: 1.036, S: 0.2118 },
      { age_yr: 0.0958, L: 0.9485, M: 1.313, S: 0.2126 },
      { age_yr: 0.1342, L: 0.9068, M: 1.679, S: 0.212 },
      { age_yr: 0.1725, L: 0.8705, M: 2.082, S: 0.2104 },
      { age_yr: 0.2108, L: 0.8384, M: 2.498, S: 0.2083 },
      { age_yr: 0.2491, L: 0.8097, M: 2.913, S: 0.2059 },
      { age_yr: 0.2917, L: 0.7809, M: 3.363, S: 0.2031 },
      { age_yr: 0.375, L: 0.732, M: 4.188, S: 0.1976 },
      { age_yr: 0.4583, L: 0.6902, M: 4.928, S: 0.1927 },
      { age_yr: 0.5417, L: 0.6532, M: 5.587, S: 0.1884 },
      { age_yr: 0.625, L: 0.6197, M: 6.17, S: 0.1847 },
      { age_yr: 0.7083, L: 0.5887, M: 6.69, S: 0.1815 },
      { age_yr: 0.7917, L: 0.5597, M: 7.159, S: 0.1788 },
      { age_yr: 0.875, L: 0.5321, M: 7.583, S: 0.1765 },
      { age_yr: 0.9583, L: 0.5057, M: 7.971, S: 0.1746 },
      { age_yr: 1.0833, L: 0.4679, M: 8.498, S: 0.1721 },
      { age_yr: 1.25, L: 0.4201, M: 9.125, S: 0.1695 },
      { age_yr: 1.4167, L: 0.3746, M: 9.688, S: 0.1675 },
    ],
    27: [
      { age_yr: 0, L: 1.0885, M: 1.042, S: 0.2031 },
      { age_yr: 0.0027, L: 1.0836, M: 1.033, S: 0.2032 },
      { age_yr: 0.0055, L: 1.0785, M: 1.026, S: 0.2034 },
      { age_yr: 0.0082, L: 1.0737, M: 1.021, S: 0.2035 },
      { age_yr: 0.011, L: 1.0688, M: 1.017, S: 0.2037 },
      { age_yr: 0.0137, L: 1.0642, M: 1.015, S: 0.2038 },
      { age_yr: 0.0164, L: 1.0596, M: 1.015, S: 0.2039 },
      { age_yr: 0.0192, L: 1.0549, M: 1.016, S: 0.204 },
      { age_yr: 0.0219, L: 1.0504, M: 1.019, S: 0.204 },
      { age_yr: 0.0246, L: 1.046, M: 1.023, S: 0.2041 },
      { age_yr: 0.0274, L: 1.0416, M: 1.029, S: 0.2042 },
      { age_yr: 0.0301, L: 1.0373000000000001, M: 1.036, S: 0.2042 },
      { age_yr: 0.0329, L: 1.0329, M: 1.044, S: 0.2042 },
      { age_yr: 0.0356, L: 1.0288, M: 1.054, S: 0.2043 },
      { age_yr: 0.0383, L: 1.0247, M: 1.064, S: 0.2043 },
      { age_yr: 0.0575, L: 0.997, M: 1.167, S: 0.2041 },
      { age_yr: 0.0958, L: 0.9485, M: 1.48, S: 0.2029 },
      { age_yr: 0.1342, L: 0.9068, M: 1.874, S: 0.2007 },
      { age_yr: 0.1725, L: 0.8705, M: 2.299, S: 0.1981 },
      { age_yr: 0.2108, L: 0.8384, M: 2.733, S: 0.1952 },
      { age_yr: 0.2491, L: 0.8097, M: 3.16, S: 0.1923 },
      { age_yr: 0.2917, L: 0.7809, M: 3.62, S: 0.1892 },
      { age_yr: 0.375, L: 0.732, M: 4.453, S: 0.1835 },
      { age_yr: 0.4583, L: 0.6902, M: 5.192, S: 0.1786 },
      { age_yr: 0.5417, L: 0.6532, M: 5.843, S: 0.1745 },
      { age_yr: 0.625, L: 0.6197, M: 6.418, S: 0.1711 },
      { age_yr: 0.7083, L: 0.5887, M: 6.93, S: 0.1683 },
      { age_yr: 0.7917, L: 0.5597, M: 7.389, S: 0.1659 },
      { age_yr: 0.875, L: 0.5321, M: 7.806, S: 0.1639 },
      { age_yr: 0.9583, L: 0.5057, M: 8.187, S: 0.1622 },
      { age_yr: 1.0833, L: 0.4679, M: 8.707, S: 0.1601 },
      { age_yr: 1.25, L: 0.4201, M: 9.326, S: 0.1579 },
      { age_yr: 1.4167, L: 0.3746, M: 9.883, S: 0.1563 },
    ],
    28: [
      { age_yr: 0, L: 1.0885, M: 1.131, S: 0.2014 },
      { age_yr: 0.0027, L: 1.0836, M: 1.126, S: 0.2014 },
      { age_yr: 0.0055, L: 1.0785, M: 1.123, S: 0.2013 },
      { age_yr: 0.0082, L: 1.0737, M: 1.121, S: 0.2012 },
      { age_yr: 0.011, L: 1.0688, M: 1.122, S: 0.2011 },
      { age_yr: 0.0137, L: 1.0642, M: 1.123, S: 0.201 },
      { age_yr: 0.0164, L: 1.0596, M: 1.127, S: 0.2009 },
      { age_yr: 0.0192, L: 1.0549, M: 1.131, S: 0.2008 },
      { age_yr: 0.0219, L: 1.0504, M: 1.138, S: 0.2006 },
      { age_yr: 0.0246, L: 1.046, M: 1.145, S: 0.2005 },
      { age_yr: 0.0274, L: 1.0416, M: 1.154, S: 0.2004 },
      { age_yr: 0.0301, L: 1.0373000000000001, M: 1.164, S: 0.2002 },
      { age_yr: 0.0329, L: 1.0329, M: 1.176, S: 0.2001 },
      { age_yr: 0.0356, L: 1.0288, M: 1.188, S: 0.1999 },
      { age_yr: 0.0383, L: 1.0247, M: 1.202, S: 0.1998 },
      { age_yr: 0.0575, L: 0.997, M: 1.324, S: 0.1985 },
      { age_yr: 0.0958, L: 0.9485, M: 1.67, S: 0.1955 },
      { age_yr: 0.1342, L: 0.9068, M: 2.09, S: 0.1921 },
      { age_yr: 0.1725, L: 0.8705, M: 2.535, S: 0.1886 },
      { age_yr: 0.2108, L: 0.8384, M: 2.984, S: 0.1852 },
      { age_yr: 0.2491, L: 0.8097, M: 3.422, S: 0.1819 },
      { age_yr: 0.2917, L: 0.7809, M: 3.889, S: 0.1785 },
      { age_yr: 0.375, L: 0.732, M: 4.727, S: 0.1727 },
      { age_yr: 0.4583, L: 0.6902, M: 5.461, S: 0.1679 },
      { age_yr: 0.5417, L: 0.6532, M: 6.106, S: 0.1639 },
      { age_yr: 0.625, L: 0.6197, M: 6.671, S: 0.1608 },
      { age_yr: 0.7083, L: 0.5887, M: 7.174, S: 0.1582 },
      { age_yr: 0.7917, L: 0.5597, M: 7.626, S: 0.156 },
      { age_yr: 0.875, L: 0.5321, M: 8.035, S: 0.1542 },
      { age_yr: 0.9583, L: 0.5057, M: 8.41, S: 0.1528 },
      { age_yr: 1.0833, L: 0.4679, M: 8.921, S: 0.151 },
      { age_yr: 1.25, L: 0.4201, M: 9.532, S: 0.1492 },
      { age_yr: 1.4167, L: 0.3746, M: 10.083, S: 0.148 },
    ],
    29: [
      { age_yr: 0, L: 1.0885, M: 1.249, S: 0.2003 },
      { age_yr: 0.0027, L: 1.0836, M: 1.248, S: 0.2 },
      { age_yr: 0.0055, L: 1.0785, M: 1.248, S: 0.1997 },
      { age_yr: 0.0082, L: 1.0737, M: 1.25, S: 0.1994 },
      { age_yr: 0.011, L: 1.0688, M: 1.254, S: 0.1991 },
      { age_yr: 0.0137, L: 1.0642, M: 1.259, S: 0.1988 },
      { age_yr: 0.0164, L: 1.0596, M: 1.265, S: 0.1985 },
      { age_yr: 0.0192, L: 1.0549, M: 1.273, S: 0.1982 },
      { age_yr: 0.0219, L: 1.0504, M: 1.283, S: 0.1979 },
      { age_yr: 0.0246, L: 1.046, M: 1.293, S: 0.1976 },
      { age_yr: 0.0274, L: 1.0416, M: 1.305, S: 0.1973 },
      { age_yr: 0.0301, L: 1.0373000000000001, M: 1.318, S: 0.197 },
      { age_yr: 0.0329, L: 1.0329, M: 1.333, S: 0.1967 },
      { age_yr: 0.0356, L: 1.0288, M: 1.348, S: 0.1964 },
      { age_yr: 0.0383, L: 1.0247, M: 1.364, S: 0.196 },
      { age_yr: 0.0575, L: 0.997, M: 1.505, S: 0.1938 },
      { age_yr: 0.0958, L: 0.9485, M: 1.882, S: 0.1894 },
      { age_yr: 0.1342, L: 0.9068, M: 2.325, S: 0.185 },
      { age_yr: 0.1725, L: 0.8705, M: 2.788, S: 0.1809 },
      { age_yr: 0.2108, L: 0.8384, M: 3.249, S: 0.177 },
      { age_yr: 0.2491, L: 0.8097, M: 3.695, S: 0.1734 },
      { age_yr: 0.2917, L: 0.7809, M: 4.167, S: 0.1698 },
      { age_yr: 0.375, L: 0.732, M: 5.005, S: 0.1639 },
      { age_yr: 0.4583, L: 0.6902, M: 5.735, S: 0.1592 },
      { age_yr: 0.5417, L: 0.6532, M: 6.37, S: 0.1554 },
      { age_yr: 0.625, L: 0.6197, M: 6.927, S: 0.1524 },
      { age_yr: 0.7083, L: 0.5887, M: 7.421, S: 0.1501 },
      { age_yr: 0.7917, L: 0.5597, M: 7.864, S: 0.1481 },
      { age_yr: 0.875, L: 0.5321, M: 8.266, S: 0.1465 },
      { age_yr: 0.9583, L: 0.5057, M: 8.634, S: 0.1452 },
      { age_yr: 1.0833, L: 0.4679, M: 9.138, S: 0.1437 },
      { age_yr: 1.25, L: 0.4201, M: 9.739, S: 0.1423 },
      { age_yr: 1.4167, L: 0.3746, M: 10.284, S: 0.1413 },
    ],
    30: [
      { age_yr: 0, L: 1.0885, M: 1.395, S: 0.1984 },
      { age_yr: 0.0027, L: 1.0836, M: 1.397, S: 0.1979 },
      { age_yr: 0.0055, L: 1.0785, M: 1.4, S: 0.1974 },
      { age_yr: 0.0082, L: 1.0737, M: 1.405, S: 0.197 },
      { age_yr: 0.011, L: 1.0688, M: 1.412, S: 0.1965 },
      { age_yr: 0.0137, L: 1.0642, M: 1.42, S: 0.196 },
      { age_yr: 0.0164, L: 1.0596, M: 1.43, S: 0.1956 },
      { age_yr: 0.0192, L: 1.0549, M: 1.441, S: 0.1951 },
      { age_yr: 0.0219, L: 1.0504, M: 1.453, S: 0.1947 },
      { age_yr: 0.0246, L: 1.046, M: 1.466, S: 0.1942 },
      { age_yr: 0.0274, L: 1.0416, M: 1.481, S: 0.1938 },
      { age_yr: 0.0301, L: 1.0373000000000001, M: 1.497, S: 0.1933 },
      { age_yr: 0.0329, L: 1.0329, M: 1.514, S: 0.1929 },
      { age_yr: 0.0356, L: 1.0288, M: 1.532, S: 0.1924 },
      { age_yr: 0.0383, L: 1.0247, M: 1.551, S: 0.192 },
      { age_yr: 0.0575, L: 0.997, M: 1.709, S: 0.189 },
      { age_yr: 0.0958, L: 0.9485, M: 2.112, S: 0.1834 },
      { age_yr: 0.1342, L: 0.9068, M: 2.576, S: 0.1783 },
      { age_yr: 0.1725, L: 0.8705, M: 3.053, S: 0.1736 },
      { age_yr: 0.2108, L: 0.8384, M: 3.523, S: 0.1694 },
      { age_yr: 0.2491, L: 0.8097, M: 3.975, S: 0.1657 },
      { age_yr: 0.2917, L: 0.7809, M: 4.45, S: 0.1619 },
      { age_yr: 0.375, L: 0.732, M: 5.286, S: 0.156 },
      { age_yr: 0.4583, L: 0.6902, M: 6.008, S: 0.1514 },
      { age_yr: 0.5417, L: 0.6532, M: 6.635, S: 0.1478 },
      { age_yr: 0.625, L: 0.6197, M: 7.183, S: 0.145 },
      { age_yr: 0.7083, L: 0.5887, M: 7.668, S: 0.1428 },
      { age_yr: 0.7917, L: 0.5597, M: 8.103, S: 0.1411 },
      { age_yr: 0.875, L: 0.5321, M: 8.497, S: 0.1397 },
      { age_yr: 0.9583, L: 0.5057, M: 8.858, S: 0.1385 },
      { age_yr: 1.0833, L: 0.4679, M: 9.353, S: 0.1372 },
      { age_yr: 1.25, L: 0.4201, M: 9.946, S: 0.1361 },
      { age_yr: 1.4167, L: 0.3746, M: 10.484, S: 0.1354 },
    ],
    31: [
      { age_yr: 0, L: 1.0885, M: 1.565, S: 0.1952 },
      { age_yr: 0.0027, L: 1.0836, M: 1.57, S: 0.1946 },
      { age_yr: 0.0055, L: 1.0785, M: 1.577, S: 0.194 },
      { age_yr: 0.0082, L: 1.0737, M: 1.585, S: 0.1934 },
      { age_yr: 0.011, L: 1.0688, M: 1.595, S: 0.1928 },
      { age_yr: 0.0137, L: 1.0642, M: 1.606, S: 0.1922 },
      { age_yr: 0.0164, L: 1.0596, M: 1.618, S: 0.1916 },
      { age_yr: 0.0192, L: 1.0549, M: 1.632, S: 0.191 },
      { age_yr: 0.0219, L: 1.0504, M: 1.646, S: 0.1905 },
      { age_yr: 0.0246, L: 1.046, M: 1.662, S: 0.1899 },
      { age_yr: 0.0274, L: 1.0416, M: 1.68, S: 0.1893 },
      { age_yr: 0.0301, L: 1.0373000000000001, M: 1.698, S: 0.1888 },
      { age_yr: 0.0329, L: 1.0329, M: 1.718, S: 0.1882 },
      { age_yr: 0.0356, L: 1.0288, M: 1.738, S: 0.1877 },
      { age_yr: 0.0383, L: 1.0247, M: 1.759, S: 0.1872 },
      { age_yr: 0.0575, L: 0.997, M: 1.932, S: 0.1836 },
      { age_yr: 0.0958, L: 0.9485, M: 2.358, S: 0.1771 },
      { age_yr: 0.1342, L: 0.9068, M: 2.838, S: 0.1714 },
      { age_yr: 0.1725, L: 0.8705, M: 3.326, S: 0.1664 },
      { age_yr: 0.2108, L: 0.8384, M: 3.802, S: 0.162 },
      { age_yr: 0.2491, L: 0.8097, M: 4.257, S: 0.1581 },
      { age_yr: 0.2917, L: 0.7809, M: 4.732, S: 0.1544 },
      { age_yr: 0.375, L: 0.732, M: 5.563, S: 0.1485 },
      { age_yr: 0.4583, L: 0.6902, M: 6.277, S: 0.144 },
      { age_yr: 0.5417, L: 0.6532, M: 6.895, S: 0.1406 },
      { age_yr: 0.625, L: 0.6197, M: 7.433, S: 0.138 },
      { age_yr: 0.7083, L: 0.5887, M: 7.909, S: 0.136 },
      { age_yr: 0.7917, L: 0.5597, M: 8.335, S: 0.1344 },
      { age_yr: 0.875, L: 0.5321, M: 8.722, S: 0.1332 },
      { age_yr: 0.9583, L: 0.5057, M: 9.077, S: 0.1322 },
      { age_yr: 1.0833, L: 0.4679, M: 9.563, S: 0.1311 },
      { age_yr: 1.25, L: 0.4201, M: 10.146, S: 0.1302 },
      { age_yr: 1.4167, L: 0.3746, M: 10.677, S: 0.1297 },
    ],
    32: [
      { age_yr: 0, L: 1.0885, M: 1.76, S: 0.1912 },
      { age_yr: 0.0027, L: 1.0836, M: 1.768, S: 0.1905 },
      { age_yr: 0.0055, L: 1.0785, M: 1.777, S: 0.1897 },
      { age_yr: 0.0082, L: 1.0737, M: 1.788, S: 0.189 },
      { age_yr: 0.011, L: 1.0688, M: 1.8, S: 0.1883 },
      { age_yr: 0.0137, L: 1.0642, M: 1.813, S: 0.1876 },
      { age_yr: 0.0164, L: 1.0596, M: 1.828, S: 0.1869 },
      { age_yr: 0.0192, L: 1.0549, M: 1.844, S: 0.1863 },
      { age_yr: 0.0219, L: 1.0504, M: 1.861, S: 0.1856 },
      { age_yr: 0.0246, L: 1.046, M: 1.879, S: 0.185 },
      { age_yr: 0.0274, L: 1.0416, M: 1.899, S: 0.1843 },
      { age_yr: 0.0301, L: 1.0373000000000001, M: 1.919, S: 0.1837 },
      { age_yr: 0.0329, L: 1.0329, M: 1.941, S: 0.183 },
      { age_yr: 0.0356, L: 1.0288, M: 1.963, S: 0.1824 },
      { age_yr: 0.0383, L: 1.0247, M: 1.986, S: 0.1818 },
      { age_yr: 0.0575, L: 0.997, M: 2.171, S: 0.1778 },
      { age_yr: 0.0958, L: 0.9485, M: 2.616, S: 0.1707 },
      { age_yr: 0.1342, L: 0.9068, M: 3.107, S: 0.1646 },
      { age_yr: 0.1725, L: 0.8705, M: 3.601, S: 0.1594 },
      { age_yr: 0.2108, L: 0.8384, M: 4.081, S: 0.1549 },
      { age_yr: 0.2491, L: 0.8097, M: 4.536, S: 0.151 },
      { age_yr: 0.2917, L: 0.7809, M: 5.009, S: 0.1473 },
      { age_yr: 0.375, L: 0.732, M: 5.833, S: 0.1415 },
      { age_yr: 0.4583, L: 0.6902, M: 6.538, S: 0.1372 },
      { age_yr: 0.5417, L: 0.6532, M: 7.145, S: 0.134 },
      { age_yr: 0.625, L: 0.6197, M: 7.674, S: 0.1316 },
      { age_yr: 0.7083, L: 0.5887, M: 8.14, S: 0.1298 },
      { age_yr: 0.7917, L: 0.5597, M: 8.559, S: 0.1283 },
      { age_yr: 0.875, L: 0.5321, M: 8.938, S: 0.1272 },
      { age_yr: 0.9583, L: 0.5057, M: 9.286, S: 0.1264 },
      { age_yr: 1.0833, L: 0.4679, M: 9.764, S: 0.1255 },
      { age_yr: 1.25, L: 0.4201, M: 10.337, S: 0.1248 },
      { age_yr: 1.4167, L: 0.3746, M: 10.86, S: 0.1245 },
    ],
    33: [
      { age_yr: 0, L: 1.0885, M: 1.98, S: 0.1867 },
      { age_yr: 0.0027, L: 1.0836, M: 1.99, S: 0.1859 },
      { age_yr: 0.0055, L: 1.0785, M: 2.001, S: 0.1851 },
      { age_yr: 0.0082, L: 1.0737, M: 2.014, S: 0.1843 },
      { age_yr: 0.011, L: 1.0688, M: 2.028, S: 0.1835 },
      { age_yr: 0.0137, L: 1.0642, M: 2.043, S: 0.1827 },
      { age_yr: 0.0164, L: 1.0596, M: 2.06, S: 0.182 },
      { age_yr: 0.0192, L: 1.0549, M: 2.078, S: 0.1812 },
      { age_yr: 0.0219, L: 1.0504, M: 2.097, S: 0.1805 },
      { age_yr: 0.0246, L: 1.046, M: 2.116, S: 0.1798 },
      { age_yr: 0.0274, L: 1.0416, M: 2.138, S: 0.1791 },
      { age_yr: 0.0301, L: 1.0373000000000001, M: 2.16, S: 0.1784 },
      { age_yr: 0.0329, L: 1.0329, M: 2.183, S: 0.1777 },
      { age_yr: 0.0356, L: 1.0288, M: 2.207, S: 0.177 },
      { age_yr: 0.0383, L: 1.0247, M: 2.231, S: 0.1764 },
      { age_yr: 0.0575, L: 0.997, M: 2.425, S: 0.172 },
      { age_yr: 0.0958, L: 0.9485, M: 2.882, S: 0.1645 },
      { age_yr: 0.1342, L: 0.9068, M: 3.38, S: 0.1582 },
      { age_yr: 0.1725, L: 0.8705, M: 3.877, S: 0.1529 },
      { age_yr: 0.2108, L: 0.8384, M: 4.356, S: 0.1484 },
      { age_yr: 0.2491, L: 0.8097, M: 4.809, S: 0.1445 },
      { age_yr: 0.2917, L: 0.7809, M: 5.279, S: 0.1409 },
      { age_yr: 0.375, L: 0.732, M: 6.094, S: 0.1353 },
      { age_yr: 0.4583, L: 0.6902, M: 6.788, S: 0.1312 },
      { age_yr: 0.5417, L: 0.6532, M: 7.385, S: 0.1282 },
      { age_yr: 0.625, L: 0.6197, M: 7.904, S: 0.1259 },
      { age_yr: 0.7083, L: 0.5887, M: 8.362, S: 0.1242 },
      { age_yr: 0.7917, L: 0.5597, M: 8.772, S: 0.1229 },
      { age_yr: 0.875, L: 0.5321, M: 9.144, S: 0.122 },
      { age_yr: 0.9583, L: 0.5057, M: 9.485, S: 0.1212 },
      { age_yr: 1.0833, L: 0.4679, M: 9.953, S: 0.1205 },
      { age_yr: 1.25, L: 0.4201, M: 10.517, S: 0.12 },
      { age_yr: 1.4167, L: 0.3746, M: 11.032, S: 0.1199 },
    ],
    34: [
      { age_yr: 0, L: 1.0885, M: 2.222, S: 0.1818 },
      { age_yr: 0.0027, L: 1.0836, M: 2.233, S: 0.1809 },
      { age_yr: 0.0055, L: 1.0785, M: 2.246, S: 0.18 },
      { age_yr: 0.0082, L: 1.0737, M: 2.26, S: 0.1792 },
      { age_yr: 0.011, L: 1.0688, M: 2.276, S: 0.1783 },
      { age_yr: 0.0137, L: 1.0642, M: 2.292, S: 0.1775 },
      { age_yr: 0.0164, L: 1.0596, M: 2.31, S: 0.1767 },
      { age_yr: 0.0192, L: 1.0549, M: 2.329, S: 0.1759 },
      { age_yr: 0.0219, L: 1.0504, M: 2.349, S: 0.1752 },
      { age_yr: 0.0246, L: 1.046, M: 2.37, S: 0.1744 },
      { age_yr: 0.0274, L: 1.0416, M: 2.393, S: 0.1737 },
      { age_yr: 0.0301, L: 1.0373000000000001, M: 2.415, S: 0.173 },
      { age_yr: 0.0329, L: 1.0329, M: 2.44, S: 0.1722 },
      { age_yr: 0.0356, L: 1.0288, M: 2.465, S: 0.1715 },
      { age_yr: 0.0383, L: 1.0247, M: 2.49, S: 0.1709 },
      { age_yr: 0.0575, L: 0.997, M: 2.689, S: 0.1663 },
      { age_yr: 0.0958, L: 0.9485, M: 3.152, S: 0.1586 },
      { age_yr: 0.1342, L: 0.9068, M: 3.651, S: 0.1522 },
      { age_yr: 0.1725, L: 0.8705, M: 4.147, S: 0.1469 },
      { age_yr: 0.2108, L: 0.8384, M: 4.624, S: 0.1424 },
      { age_yr: 0.2491, L: 0.8097, M: 5.073, S: 0.1386 },
      { age_yr: 0.2917, L: 0.7809, M: 5.538, S: 0.1351 },
      { age_yr: 0.375, L: 0.732, M: 6.342, S: 0.1296 },
      { age_yr: 0.4583, L: 0.6902, M: 7.026, S: 0.1258 },
      { age_yr: 0.5417, L: 0.6532, M: 7.612, S: 0.1229 },
      { age_yr: 0.625, L: 0.6197, M: 8.121, S: 0.1209 },
      { age_yr: 0.7083, L: 0.5887, M: 8.569, S: 0.1193 },
      { age_yr: 0.7917, L: 0.5597, M: 8.971, S: 0.1181 },
      { age_yr: 0.875, L: 0.5321, M: 9.335, S: 0.1173 },
      { age_yr: 0.9583, L: 0.5057, M: 9.67, S: 0.1167 },
      { age_yr: 1.0833, L: 0.4679, M: 10.129, S: 0.1161 },
      { age_yr: 1.25, L: 0.4201, M: 10.683, S: 0.1158 },
      { age_yr: 1.4167, L: 0.3746, M: 11.189, S: 0.1159 },
    ],
    35: [
      { age_yr: 0, L: 1.0885, M: 2.479, S: 0.1762 },
      { age_yr: 0.0027, L: 1.0836, M: 2.491, S: 0.1753 },
      { age_yr: 0.0055, L: 1.0785, M: 2.505, S: 0.1743 },
      { age_yr: 0.0082, L: 1.0737, M: 2.52, S: 0.1735 },
      { age_yr: 0.011, L: 1.0688, M: 2.536, S: 0.1726 },
      { age_yr: 0.0137, L: 1.0642, M: 2.553, S: 0.1718 },
      { age_yr: 0.0164, L: 1.0596, M: 2.572, S: 0.171 },
      { age_yr: 0.0192, L: 1.0549, M: 2.592, S: 0.1702 },
      { age_yr: 0.0219, L: 1.0504, M: 2.612, S: 0.1694 },
      { age_yr: 0.0246, L: 1.046, M: 2.633, S: 0.1686 },
      { age_yr: 0.0274, L: 1.0416, M: 2.656, S: 0.1679 },
      { age_yr: 0.0301, L: 1.0373000000000001, M: 2.68, S: 0.1671 },
      { age_yr: 0.0329, L: 1.0329, M: 2.704, S: 0.1664 },
      { age_yr: 0.0356, L: 1.0288, M: 2.729, S: 0.1657 },
      { age_yr: 0.0383, L: 1.0247, M: 2.755, S: 0.165 },
      { age_yr: 0.0575, L: 0.997, M: 2.956, S: 0.1604 },
      { age_yr: 0.0958, L: 0.9485, M: 3.419, S: 0.1526 },
      { age_yr: 0.1342, L: 0.9068, M: 3.916, S: 0.1463 },
      { age_yr: 0.1725, L: 0.8705, M: 4.408, S: 0.1411 },
      { age_yr: 0.2108, L: 0.8384, M: 4.879, S: 0.1367 },
      { age_yr: 0.2491, L: 0.8097, M: 5.323, S: 0.133 },
      { age_yr: 0.2917, L: 0.7809, M: 5.782, S: 0.1296 },
      { age_yr: 0.375, L: 0.732, M: 6.574, S: 0.1244 },
      { age_yr: 0.4583, L: 0.6902, M: 7.245, S: 0.1207 },
      { age_yr: 0.5417, L: 0.6532, M: 7.821, S: 0.1181 },
      { age_yr: 0.625, L: 0.6197, M: 8.319, S: 0.1161 },
      { age_yr: 0.7083, L: 0.5887, M: 8.759, S: 0.1147 },
      { age_yr: 0.7917, L: 0.5597, M: 9.153, S: 0.1137 },
      { age_yr: 0.875, L: 0.5321, M: 9.509, S: 0.1129 },
      { age_yr: 0.9583, L: 0.5057, M: 9.837, S: 0.1124 },
      { age_yr: 1.0833, L: 0.4679, M: 10.287, S: 0.1119 },
      { age_yr: 1.25, L: 0.4201, M: 10.83, S: 0.1118 },
      { age_yr: 1.4167, L: 0.3746, M: 11.328, S: 0.112 },
    ],
    36: [
      { age_yr: 0, L: 1.0885, M: 2.745, S: 0.1702 },
      { age_yr: 0.0027, L: 1.0836, M: 2.757, S: 0.1693 },
      { age_yr: 0.0055, L: 1.0785, M: 2.771, S: 0.1684 },
      { age_yr: 0.0082, L: 1.0737, M: 2.786, S: 0.1675 },
      { age_yr: 0.011, L: 1.0688, M: 2.802, S: 0.1666 },
      { age_yr: 0.0137, L: 1.0642, M: 2.819, S: 0.1658 },
      { age_yr: 0.0164, L: 1.0596, M: 2.837, S: 0.165 },
      { age_yr: 0.0192, L: 1.0549, M: 2.857, S: 0.1642 },
      { age_yr: 0.0219, L: 1.0504, M: 2.877, S: 0.1634 },
      { age_yr: 0.0246, L: 1.046, M: 2.899, S: 0.1627 },
      { age_yr: 0.0274, L: 1.0416, M: 2.922, S: 0.1619 },
      { age_yr: 0.0301, L: 1.0373000000000001, M: 2.945, S: 0.1612 },
      { age_yr: 0.0329, L: 1.0329, M: 2.969, S: 0.1604 },
      { age_yr: 0.0356, L: 1.0288, M: 2.994, S: 0.1597 },
      { age_yr: 0.0383, L: 1.0247, M: 3.02, S: 0.159 },
      { age_yr: 0.0575, L: 0.997, M: 3.218, S: 0.1545 },
      { age_yr: 0.0958, L: 0.9485, M: 3.677, S: 0.1468 },
      { age_yr: 0.1342, L: 0.9068, M: 4.168, S: 0.1407 },
      { age_yr: 0.1725, L: 0.8705, M: 4.653, S: 0.1356 },
      { age_yr: 0.2108, L: 0.8384, M: 5.118, S: 0.1313 },
      { age_yr: 0.2491, L: 0.8097, M: 5.555, S: 0.1278 },
      { age_yr: 0.2917, L: 0.7809, M: 6.006, S: 0.1245 },
      { age_yr: 0.375, L: 0.732, M: 6.785, S: 0.1196 },
      { age_yr: 0.4583, L: 0.6902, M: 7.444, S: 0.1161 },
      { age_yr: 0.5417, L: 0.6532, M: 8.009, S: 0.1136 },
      { age_yr: 0.625, L: 0.6197, M: 8.497, S: 0.1118 },
      { age_yr: 0.7083, L: 0.5887, M: 8.928, S: 0.1105 },
      { age_yr: 0.7917, L: 0.5597, M: 9.313, S: 0.1096 },
      { age_yr: 0.875, L: 0.5321, M: 9.663, S: 0.109 },
      { age_yr: 0.9583, L: 0.5057, M: 9.984, S: 0.1085 },
      { age_yr: 1.0833, L: 0.4679, M: 10.424, S: 0.1082 },
      { age_yr: 1.25, L: 0.4201, M: 10.957, S: 0.1082 },
      { age_yr: 1.4167, L: 0.3746, M: 11.445, S: 0.1085 },
    ],
  },
  F: {
    25: [
      { age_yr: 0, L: 0.8089, M: 0.877, S: 0.1805 },
      { age_yr: 0.0027, L: 0.8128, M: 0.861, S: 0.1796 },
      { age_yr: 0.0055, L: 0.8167, M: 0.846, S: 0.1786 },
      { age_yr: 0.0082, L: 0.8204, M: 0.833, S: 0.1777 },
      { age_yr: 0.011, L: 0.824, M: 0.823, S: 0.1768 },
      { age_yr: 0.0137, L: 0.8274, M: 0.814, S: 0.176 },
      { age_yr: 0.0164, L: 0.8307, M: 0.806, S: 0.1752 },
      { age_yr: 0.0192, L: 0.8339, M: 0.801, S: 0.1743 },
      { age_yr: 0.0219, L: 0.837, M: 0.797, S: 0.1735 },
      { age_yr: 0.0246, L: 0.8399, M: 0.794, S: 0.1727 },
      { age_yr: 0.0274, L: 0.8429, M: 0.793, S: 0.1719 },
      { age_yr: 0.0301, L: 0.8456, M: 0.793, S: 0.1712 },
      { age_yr: 0.0329, L: 0.8484, M: 0.794, S: 0.1704 },
      { age_yr: 0.0356, L: 0.851, M: 0.797, S: 0.1697 },
      { age_yr: 0.0383, L: 0.8534, M: 0.801, S: 0.1689 },
      { age_yr: 0.0575, L: 0.8687, M: 0.858, S: 0.1641 },
      { age_yr: 0.0958, L: 0.8893, M: 1.085, S: 0.1559 },
      { age_yr: 0.1342, L: 0.9003, M: 1.4, S: 0.1492 },
      { age_yr: 0.1725, L: 0.9043, M: 1.754, S: 0.1435 },
      { age_yr: 0.2108, L: 0.9034, M: 2.124, S: 0.1387 },
      { age_yr: 0.2491, L: 0.8988, M: 2.496, S: 0.1346 },
      { age_yr: 0.2917, L: 0.8904, M: 2.902, S: 0.1307 },
      { age_yr: 0.375, L: 0.8675, M: 3.655, S: 0.1247 },
      { age_yr: 0.4583, L: 0.8391, M: 4.339, S: 0.1203 },
      { age_yr: 0.5417, L: 0.8079, M: 4.952, S: 0.1171 },
      { age_yr: 0.625, L: 0.7752, M: 5.499, S: 0.1147 },
      { age_yr: 0.7083, L: 0.7418, M: 5.989, S: 0.1129 },
      { age_yr: 0.7917, L: 0.7083, M: 6.432, S: 0.1115 },
      { age_yr: 0.875, L: 0.675, M: 6.835, S: 0.1104 },
      { age_yr: 0.9583, L: 0.642, M: 7.206, S: 0.1096 },
      { age_yr: 1.0833, L: 0.5935, M: 7.712, S: 0.1087 },
      { age_yr: 1.25, L: 0.5307, M: 8.319, S: 0.1077 },
      { age_yr: 1.4167, L: 0.4701, M: 8.869, S: 0.1071 },
    ],
    26: [
      { age_yr: 0, L: 0.8089, M: 0.901, S: 0.194 },
      { age_yr: 0.0027, L: 0.8128, M: 0.89, S: 0.193 },
      { age_yr: 0.0055, L: 0.8167, M: 0.88, S: 0.192 },
      { age_yr: 0.0082, L: 0.8204, M: 0.872, S: 0.1911 },
      { age_yr: 0.011, L: 0.824, M: 0.866, S: 0.1901 },
      { age_yr: 0.0137, L: 0.8274, M: 0.861, S: 0.1893 },
      { age_yr: 0.0164, L: 0.8307, M: 0.858, S: 0.1884 },
      { age_yr: 0.0192, L: 0.8339, M: 0.857, S: 0.1875 },
      { age_yr: 0.0219, L: 0.837, M: 0.857, S: 0.1866 },
      { age_yr: 0.0246, L: 0.8399, M: 0.858, S: 0.1858 },
      { age_yr: 0.0274, L: 0.8429, M: 0.861, S: 0.185 },
      { age_yr: 0.0301, L: 0.8456, M: 0.865, S: 0.1842 },
      { age_yr: 0.0329, L: 0.8484, M: 0.87, S: 0.1834 },
      { age_yr: 0.0356, L: 0.851, M: 0.876, S: 0.1826 },
      { age_yr: 0.0383, L: 0.8534, M: 0.884, S: 0.1818 },
      { age_yr: 0.0575, L: 0.8687, M: 0.964, S: 0.1768 },
      { age_yr: 0.0958, L: 0.8893, M: 1.229, S: 0.1682 },
      { age_yr: 0.1342, L: 0.9003, M: 1.572, S: 0.161 },
      { age_yr: 0.1725, L: 0.9043, M: 1.947, S: 0.155 },
      { age_yr: 0.2108, L: 0.9034, M: 2.333, S: 0.1499 },
      { age_yr: 0.2491, L: 0.8988, M: 2.716, S: 0.1456 },
      { age_yr: 0.2917, L: 0.8904, M: 3.131, S: 0.1414 },
      { age_yr: 0.375, L: 0.8675, M: 3.891, S: 0.1351 },
      { age_yr: 0.4583, L: 0.8391, M: 4.573, S: 0.1304 },
      { age_yr: 0.5417, L: 0.8079, M: 5.18, S: 0.127 },
      { age_yr: 0.625, L: 0.7752, M: 5.72, S: 0.1245 },
      { age_yr: 0.7083, L: 0.7418, M: 6.203, S: 0.1226 },
      { age_yr: 0.7917, L: 0.7083, M: 6.639, S: 0.1212 },
      { age_yr: 0.875, L: 0.675, M: 7.035, S: 0.1201 },
      { age_yr: 0.9583, L: 0.642, M: 7.4, S: 0.1193 },
      { age_yr: 1.0833, L: 0.5935, M: 7.9, S: 0.1184 },
      { age_yr: 1.25, L: 0.5307, M: 8.5, S: 0.1175 },
      { age_yr: 1.4167, L: 0.4701, M: 9.046, S: 0.117 },
    ],
    27: [
      { age_yr: 0, L: 0.8089, M: 0.953, S: 0.2035 },
      { age_yr: 0.0027, L: 0.8128, M: 0.946, S: 0.2026 },
      { age_yr: 0.0055, L: 0.8167, M: 0.941, S: 0.2016 },
      { age_yr: 0.0082, L: 0.8204, M: 0.937, S: 0.2006 },
      { age_yr: 0.011, L: 0.824, M: 0.935, S: 0.1996 },
      { age_yr: 0.0137, L: 0.8274, M: 0.935, S: 0.1987 },
      { age_yr: 0.0164, L: 0.8307, M: 0.935, S: 0.1978 },
      { age_yr: 0.0192, L: 0.8339, M: 0.938, S: 0.1969 },
      { age_yr: 0.0219, L: 0.837, M: 0.941, S: 0.1961 },
      { age_yr: 0.0246, L: 0.8399, M: 0.946, S: 0.1952 },
      { age_yr: 0.0274, L: 0.8429, M: 0.953, S: 0.1943 },
      { age_yr: 0.0301, L: 0.8456, M: 0.96, S: 0.1935 },
      { age_yr: 0.0329, L: 0.8484, M: 0.969, S: 0.1927 },
      { age_yr: 0.0356, L: 0.851, M: 0.979, S: 0.1919 },
      { age_yr: 0.0383, L: 0.8534, M: 0.989, S: 0.1911 },
      { age_yr: 0.0575, L: 0.8687, M: 1.091, S: 0.1859 },
      { age_yr: 0.0958, L: 0.8893, M: 1.389, S: 0.1771 },
      { age_yr: 0.1342, L: 0.9003, M: 1.757, S: 0.1697 },
      { age_yr: 0.1725, L: 0.9043, M: 2.152, S: 0.1635 },
      { age_yr: 0.2108, L: 0.9034, M: 2.552, S: 0.1582 },
      { age_yr: 0.2491, L: 0.8988, M: 2.944, S: 0.1537 },
      { age_yr: 0.2917, L: 0.8904, M: 3.366, S: 0.1494 },
      { age_yr: 0.375, L: 0.8675, M: 4.129, S: 0.1428 },
      { age_yr: 0.4583, L: 0.8391, M: 4.808, S: 0.1381 },
      { age_yr: 0.5417, L: 0.8079, M: 5.409, S: 0.1346 },
      { age_yr: 0.625, L: 0.7752, M: 5.941, S: 0.132 },
      { age_yr: 0.7083, L: 0.7418, M: 6.416, S: 0.1301 },
      { age_yr: 0.7917, L: 0.7083, M: 6.845, S: 0.1287 },
      { age_yr: 0.875, L: 0.675, M: 7.236, S: 0.1276 },
      { age_yr: 0.9583, L: 0.642, M: 7.595, S: 0.1268 },
      { age_yr: 1.0833, L: 0.5935, M: 8.088, S: 0.1259 },
      { age_yr: 1.25, L: 0.5307, M: 8.682, S: 0.1251 },
      { age_yr: 1.4167, L: 0.4701, M: 9.223, S: 0.1247 },
    ],
    28: [
      { age_yr: 0, L: 0.8089, M: 1.034, S: 0.2086 },
      { age_yr: 0.0027, L: 0.8128, M: 1.031, S: 0.2076 },
      { age_yr: 0.0055, L: 0.8167, M: 1.029, S: 0.2066 },
      { age_yr: 0.0082, L: 0.8204, M: 1.03, S: 0.2057 },
      { age_yr: 0.011, L: 0.824, M: 1.031, S: 0.2047 },
      { age_yr: 0.0137, L: 0.8274, M: 1.034, S: 0.2038 },
      { age_yr: 0.0164, L: 0.8307, M: 1.039, S: 0.2029 },
      { age_yr: 0.0192, L: 0.8339, M: 1.045, S: 0.202 },
      { age_yr: 0.0219, L: 0.837, M: 1.052, S: 0.2011 },
      { age_yr: 0.0246, L: 0.8399, M: 1.06, S: 0.2002 },
      { age_yr: 0.0274, L: 0.8429, M: 1.069, S: 0.1994 },
      { age_yr: 0.0301, L: 0.8456, M: 1.08, S: 0.1986 },
      { age_yr: 0.0329, L: 0.8484, M: 1.092, S: 0.1977 },
      { age_yr: 0.0356, L: 0.851, M: 1.104, S: 0.1969 },
      { age_yr: 0.0383, L: 0.8534, M: 1.118, S: 0.1961 },
      { age_yr: 0.0575, L: 0.8687, M: 1.238, S: 0.1909 },
      { age_yr: 0.0958, L: 0.8893, M: 1.567, S: 0.182 },
      { age_yr: 0.1342, L: 0.9003, M: 1.958, S: 0.1746 },
      { age_yr: 0.1725, L: 0.9043, M: 2.369, S: 0.1683 },
      { age_yr: 0.2108, L: 0.9034, M: 2.78, S: 0.163 },
      { age_yr: 0.2491, L: 0.8988, M: 3.18, S: 0.1584 },
      { age_yr: 0.2917, L: 0.8904, M: 3.606, S: 0.1541 },
      { age_yr: 0.375, L: 0.8675, M: 4.371, S: 0.1475 },
      { age_yr: 0.4583, L: 0.8391, M: 5.045, S: 0.1427 },
      { age_yr: 0.5417, L: 0.8079, M: 5.639, S: 0.1392 },
      { age_yr: 0.625, L: 0.7752, M: 6.163, S: 0.1366 },
      { age_yr: 0.7083, L: 0.7418, M: 6.63, S: 0.1348 },
      { age_yr: 0.7917, L: 0.7083, M: 7.052, S: 0.1333 },
      { age_yr: 0.875, L: 0.675, M: 7.436, S: 0.1323 },
      { age_yr: 0.9583, L: 0.642, M: 7.79, S: 0.1315 },
      { age_yr: 1.0833, L: 0.5935, M: 8.277, S: 0.1307 },
      { age_yr: 1.25, L: 0.5307, M: 8.863, S: 0.1301 },
      { age_yr: 1.4167, L: 0.4701, M: 9.4, S: 0.1298 },
    ],
    29: [
      { age_yr: 0, L: 0.8089, M: 1.144, S: 0.2089 },
      { age_yr: 0.0027, L: 0.8128, M: 1.145, S: 0.208 },
      { age_yr: 0.0055, L: 0.8167, M: 1.147, S: 0.207 },
      { age_yr: 0.0082, L: 0.8204, M: 1.15, S: 0.206 },
      { age_yr: 0.011, L: 0.824, M: 1.156, S: 0.2051 },
      { age_yr: 0.0137, L: 0.8274, M: 1.162, S: 0.2042 },
      { age_yr: 0.0164, L: 0.8307, M: 1.169, S: 0.2033 },
      { age_yr: 0.0192, L: 0.8339, M: 1.178, S: 0.2024 },
      { age_yr: 0.0219, L: 0.837, M: 1.188, S: 0.2016 },
      { age_yr: 0.0246, L: 0.8399, M: 1.199, S: 0.2007 },
      { age_yr: 0.0274, L: 0.8429, M: 1.212, S: 0.1999 },
      { age_yr: 0.0301, L: 0.8456, M: 1.225, S: 0.1991 },
      { age_yr: 0.0329, L: 0.8484, M: 1.24, S: 0.1983 },
      { age_yr: 0.0356, L: 0.851, M: 1.255, S: 0.1975 },
      { age_yr: 0.0383, L: 0.8534, M: 1.272, S: 0.1967 },
      { age_yr: 0.0575, L: 0.8687, M: 1.409, S: 0.1916 },
      { age_yr: 0.0958, L: 0.8893, M: 1.764, S: 0.1828 },
      { age_yr: 0.1342, L: 0.9003, M: 2.174, S: 0.1755 },
      { age_yr: 0.1725, L: 0.9043, M: 2.598, S: 0.1693 },
      { age_yr: 0.2108, L: 0.9034, M: 3.018, S: 0.164 },
      { age_yr: 0.2491, L: 0.8988, M: 3.423, S: 0.1595 },
      { age_yr: 0.2917, L: 0.8904, M: 3.852, S: 0.1553 },
      { age_yr: 0.375, L: 0.8675, M: 4.616, S: 0.1488 },
      { age_yr: 0.4583, L: 0.8391, M: 5.284, S: 0.1441 },
      { age_yr: 0.5417, L: 0.8079, M: 5.87, S: 0.1407 },
      { age_yr: 0.625, L: 0.7752, M: 6.386, S: 0.1382 },
      { age_yr: 0.7083, L: 0.7418, M: 6.846, S: 0.1364 },
      { age_yr: 0.7917, L: 0.7083, M: 7.261, S: 0.135 },
      { age_yr: 0.875, L: 0.675, M: 7.639, S: 0.134 },
      { age_yr: 0.9583, L: 0.642, M: 7.987, S: 0.1333 },
      { age_yr: 1.0833, L: 0.5935, M: 8.466, S: 0.1326 },
      { age_yr: 1.25, L: 0.5307, M: 9.046, S: 0.1321 },
      { age_yr: 1.4167, L: 0.4701, M: 9.578, S: 0.132 },
    ],
    30: [
      { age_yr: 0, L: 0.8089, M: 1.285, S: 0.2051 },
      { age_yr: 0.0027, L: 0.8128, M: 1.289, S: 0.2042 },
      { age_yr: 0.0055, L: 0.8167, M: 1.294, S: 0.2032 },
      { age_yr: 0.0082, L: 0.8204, M: 1.3, S: 0.2024 },
      { age_yr: 0.011, L: 0.824, M: 1.308, S: 0.2014 },
      { age_yr: 0.0137, L: 0.8274, M: 1.317, S: 0.2006 },
      { age_yr: 0.0164, L: 0.8307, M: 1.328, S: 0.1997 },
      { age_yr: 0.0192, L: 0.8339, M: 1.34, S: 0.1989 },
      { age_yr: 0.0219, L: 0.837, M: 1.352, S: 0.1981 },
      { age_yr: 0.0246, L: 0.8399, M: 1.366, S: 0.1973 },
      { age_yr: 0.0274, L: 0.8429, M: 1.381, S: 0.1964 },
      { age_yr: 0.0301, L: 0.8456, M: 1.397, S: 0.1957 },
      { age_yr: 0.0329, L: 0.8484, M: 1.414, S: 0.1949 },
      { age_yr: 0.0356, L: 0.851, M: 1.432, S: 0.1941 },
      { age_yr: 0.0383, L: 0.8534, M: 1.45, S: 0.1934 },
      { age_yr: 0.0575, L: 0.8687, M: 1.602, S: 0.1884 },
      { age_yr: 0.0958, L: 0.8893, M: 1.979, S: 0.18 },
      { age_yr: 0.1342, L: 0.9003, M: 2.405, S: 0.1729 },
      { age_yr: 0.1725, L: 0.9043, M: 2.839, S: 0.1669 },
      { age_yr: 0.2108, L: 0.9034, M: 3.265, S: 0.1618 },
      { age_yr: 0.2491, L: 0.8988, M: 3.674, S: 0.1575 },
      { age_yr: 0.2917, L: 0.8904, M: 4.103, S: 0.1534 },
      { age_yr: 0.375, L: 0.8675, M: 4.864, S: 0.1471 },
      { age_yr: 0.4583, L: 0.8391, M: 5.525, S: 0.1426 },
      { age_yr: 0.5417, L: 0.8079, M: 6.103, S: 0.1394 },
      { age_yr: 0.625, L: 0.7752, M: 6.611, S: 0.137 },
      { age_yr: 0.7083, L: 0.7418, M: 7.063, S: 0.1353 },
      { age_yr: 0.7917, L: 0.7083, M: 7.471, S: 0.134 },
      { age_yr: 0.875, L: 0.675, M: 7.842, S: 0.1331 },
      { age_yr: 0.9583, L: 0.642, M: 8.185, S: 0.1324 },
      { age_yr: 1.0833, L: 0.5935, M: 8.657, S: 0.1318 },
      { age_yr: 1.25, L: 0.5307, M: 9.229, S: 0.1315 },
      { age_yr: 1.4167, L: 0.4701, M: 9.755, S: 0.1315 },
    ],
    31: [
      { age_yr: 0, L: 0.8089, M: 1.452, S: 0.1984 },
      { age_yr: 0.0027, L: 0.8128, M: 1.458, S: 0.1975 },
      { age_yr: 0.0055, L: 0.8167, M: 1.466, S: 0.1966 },
      { age_yr: 0.0082, L: 0.8204, M: 1.475, S: 0.1958 },
      { age_yr: 0.011, L: 0.824, M: 1.485, S: 0.1949 },
      { age_yr: 0.0137, L: 0.8274, M: 1.497, S: 0.1941 },
      { age_yr: 0.0164, L: 0.8307, M: 1.51, S: 0.1933 },
      { age_yr: 0.0192, L: 0.8339, M: 1.524, S: 0.1925 },
      { age_yr: 0.0219, L: 0.837, M: 1.539, S: 0.1917 },
      { age_yr: 0.0246, L: 0.8399, M: 1.554, S: 0.1909 },
      { age_yr: 0.0274, L: 0.8429, M: 1.572, S: 0.1901 },
      { age_yr: 0.0301, L: 0.8456, M: 1.59, S: 0.1894 },
      { age_yr: 0.0329, L: 0.8484, M: 1.609, S: 0.1887 },
      { age_yr: 0.0356, L: 0.851, M: 1.629, S: 0.1879 },
      { age_yr: 0.0383, L: 0.8534, M: 1.649, S: 0.1872 },
      { age_yr: 0.0575, L: 0.8687, M: 1.813, S: 0.1825 },
      { age_yr: 0.0958, L: 0.8893, M: 2.208, S: 0.1745 },
      { age_yr: 0.1342, L: 0.9003, M: 2.645, S: 0.1677 },
      { age_yr: 0.1725, L: 0.9043, M: 3.087, S: 0.1621 },
      { age_yr: 0.2108, L: 0.9034, M: 3.516, S: 0.1572 },
      { age_yr: 0.2491, L: 0.8988, M: 3.926, S: 0.15310000000000001 },
      { age_yr: 0.2917, L: 0.8904, M: 4.354, S: 0.1492 },
      { age_yr: 0.375, L: 0.8675, M: 5.109, S: 0.1433 },
      { age_yr: 0.4583, L: 0.8391, M: 5.763, S: 0.139 },
      { age_yr: 0.5417, L: 0.8079, M: 6.332, S: 0.136 },
      { age_yr: 0.625, L: 0.7752, M: 6.832, S: 0.1337 },
      { age_yr: 0.7083, L: 0.7418, M: 7.276, S: 0.1321 },
      { age_yr: 0.7917, L: 0.7083, M: 7.677, S: 0.131 },
      { age_yr: 0.875, L: 0.675, M: 8.042, S: 0.1302 },
      { age_yr: 0.9583, L: 0.642, M: 8.379, S: 0.1296 },
      { age_yr: 1.0833, L: 0.5935, M: 8.844, S: 0.1291 },
      { age_yr: 1.25, L: 0.5307, M: 9.408, S: 0.1289 },
      { age_yr: 1.4167, L: 0.4701, M: 9.928, S: 0.1291 },
    ],
    32: [
      { age_yr: 0, L: 0.8089, M: 1.641, S: 0.19 },
      { age_yr: 0.0027, L: 0.8128, M: 1.649, S: 0.1891 },
      { age_yr: 0.0055, L: 0.8167, M: 1.659, S: 0.1883 },
      { age_yr: 0.0082, L: 0.8204, M: 1.67, S: 0.1875 },
      { age_yr: 0.011, L: 0.824, M: 1.683, S: 0.1867 },
      { age_yr: 0.0137, L: 0.8274, M: 1.697, S: 0.1859 },
      { age_yr: 0.0164, L: 0.8307, M: 1.711, S: 0.1852 },
      { age_yr: 0.0192, L: 0.8339, M: 1.727, S: 0.1844 },
      { age_yr: 0.0219, L: 0.837, M: 1.744, S: 0.1837 },
      { age_yr: 0.0246, L: 0.8399, M: 1.761, S: 0.183 },
      { age_yr: 0.0274, L: 0.8429, M: 1.78, S: 0.1822 },
      { age_yr: 0.0301, L: 0.8456, M: 1.8, S: 0.1815 },
      { age_yr: 0.0329, L: 0.8484, M: 1.821, S: 0.1808 },
      { age_yr: 0.0356, L: 0.851, M: 1.842, S: 0.1802 },
      { age_yr: 0.0383, L: 0.8534, M: 1.864, S: 0.1795 },
      { age_yr: 0.0575, L: 0.8687, M: 2.037, S: 0.1751 },
      { age_yr: 0.0958, L: 0.8893, M: 2.445, S: 0.1675 },
      { age_yr: 0.1342, L: 0.9003, M: 2.89, S: 0.1612 },
      { age_yr: 0.1725, L: 0.9043, M: 3.335, S: 0.1558 },
      { age_yr: 0.2108, L: 0.9034, M: 3.765, S: 0.1513 },
      { age_yr: 0.2491, L: 0.8988, M: 4.174, S: 0.1474 },
      { age_yr: 0.2917, L: 0.8904, M: 4.6, S: 0.1438 },
      { age_yr: 0.375, L: 0.8675, M: 5.348, S: 0.1382 },
      { age_yr: 0.4583, L: 0.8391, M: 5.993, S: 0.1342 },
      { age_yr: 0.5417, L: 0.8079, M: 6.554, S: 0.1314 },
      { age_yr: 0.625, L: 0.7752, M: 7.045, S: 0.1293 },
      { age_yr: 0.7083, L: 0.7418, M: 7.481, S: 0.1278 },
      { age_yr: 0.7917, L: 0.7083, M: 7.875, S: 0.1268 },
      { age_yr: 0.875, L: 0.675, M: 8.234, S: 0.126 },
      { age_yr: 0.9583, L: 0.642, M: 8.565, S: 0.1256 },
      { age_yr: 1.0833, L: 0.5935, M: 9.022, S: 0.1252 },
      { age_yr: 1.25, L: 0.5307, M: 9.579, S: 0.1251 },
      { age_yr: 1.4167, L: 0.4701, M: 10.092, S: 0.1254 },
    ],
    33: [
      { age_yr: 0, L: 0.8089, M: 1.851, S: 0.1808 },
      { age_yr: 0.0027, L: 0.8128, M: 1.861, S: 0.1801 },
      { age_yr: 0.0055, L: 0.8167, M: 1.873, S: 0.1793 },
      { age_yr: 0.0082, L: 0.8204, M: 1.885, S: 0.1785 },
      { age_yr: 0.011, L: 0.824, M: 1.9, S: 0.1778 },
      { age_yr: 0.0137, L: 0.8274, M: 1.914, S: 0.1771 },
      { age_yr: 0.0164, L: 0.8307, M: 1.93, S: 0.1764 },
      { age_yr: 0.0192, L: 0.8339, M: 1.948, S: 0.1756 },
      { age_yr: 0.0219, L: 0.837, M: 1.966, S: 0.175 },
      { age_yr: 0.0246, L: 0.8399, M: 1.985, S: 0.1743 },
      { age_yr: 0.0274, L: 0.8429, M: 2.005, S: 0.1736 },
      { age_yr: 0.0301, L: 0.8456, M: 2.026, S: 0.173 },
      { age_yr: 0.0329, L: 0.8484, M: 2.048, S: 0.1723 },
      { age_yr: 0.0356, L: 0.851, M: 2.07, S: 0.1717 },
      { age_yr: 0.0383, L: 0.8534, M: 2.093, S: 0.1711 },
      { age_yr: 0.0575, L: 0.8687, M: 2.272, S: 0.1669 },
      { age_yr: 0.0958, L: 0.8893, M: 2.688, S: 0.1599 },
      { age_yr: 0.1342, L: 0.9003, M: 3.137, S: 0.1539 },
      { age_yr: 0.1725, L: 0.9043, M: 3.582, S: 0.149 },
      { age_yr: 0.2108, L: 0.9034, M: 4.011, S: 0.1447 },
      { age_yr: 0.2491, L: 0.8988, M: 4.418, S: 0.1411 },
      { age_yr: 0.2917, L: 0.8904, M: 4.84, S: 0.1377 },
      { age_yr: 0.375, L: 0.8675, M: 5.579, S: 0.1325 },
      { age_yr: 0.4583, L: 0.8391, M: 6.215, S: 0.1288 },
      { age_yr: 0.5417, L: 0.8079, M: 6.766, S: 0.1262 },
      { age_yr: 0.625, L: 0.7752, M: 7.249, S: 0.1243 },
      { age_yr: 0.7083, L: 0.7418, M: 7.677, S: 0.1229 },
      { age_yr: 0.7917, L: 0.7083, M: 8.064, S: 0.122 },
      { age_yr: 0.875, L: 0.675, M: 8.416, S: 0.1214 },
      { age_yr: 0.9583, L: 0.642, M: 8.742, S: 0.121 },
      { age_yr: 1.0833, L: 0.5935, M: 9.192, S: 0.1207 },
      { age_yr: 1.25, L: 0.5307, M: 9.74, S: 0.1207 },
      { age_yr: 1.4167, L: 0.4701, M: 10.247, S: 0.1211 },
    ],
    34: [
      { age_yr: 0, L: 0.8089, M: 2.08, S: 0.1718 },
      { age_yr: 0.0027, L: 0.8128, M: 2.091, S: 0.1711 },
      { age_yr: 0.0055, L: 0.8167, M: 2.104, S: 0.1704 },
      { age_yr: 0.0082, L: 0.8204, M: 2.118, S: 0.1697 },
      { age_yr: 0.011, L: 0.824, M: 2.133, S: 0.169 },
      { age_yr: 0.0137, L: 0.8274, M: 2.149, S: 0.1683 },
      { age_yr: 0.0164, L: 0.8307, M: 2.166, S: 0.1677 },
      { age_yr: 0.0192, L: 0.8339, M: 2.184, S: 0.167 },
      { age_yr: 0.0219, L: 0.837, M: 2.203, S: 0.1664 },
      { age_yr: 0.0246, L: 0.8399, M: 2.222, S: 0.1657 },
      { age_yr: 0.0274, L: 0.8429, M: 2.243, S: 0.1651 },
      { age_yr: 0.0301, L: 0.8456, M: 2.264, S: 0.1645 },
      { age_yr: 0.0329, L: 0.8484, M: 2.287, S: 0.1639 },
      { age_yr: 0.0356, L: 0.851, M: 2.31, S: 0.1633 },
      { age_yr: 0.0383, L: 0.8534, M: 2.333, S: 0.1627 },
      { age_yr: 0.0575, L: 0.8687, M: 2.516, S: 0.1589 },
      { age_yr: 0.0958, L: 0.8893, M: 2.935, S: 0.1523 },
      { age_yr: 0.1342, L: 0.9003, M: 3.383, S: 0.1468 },
      { age_yr: 0.1725, L: 0.9043, M: 3.827, S: 0.1421 },
      { age_yr: 0.2108, L: 0.9034, M: 4.253, S: 0.1382 },
      { age_yr: 0.2491, L: 0.8988, M: 4.655, S: 0.1348 },
      { age_yr: 0.2917, L: 0.8904, M: 5.072, S: 0.1316 },
      { age_yr: 0.375, L: 0.8675, M: 5.801, S: 0.1268 },
      { age_yr: 0.4583, L: 0.8391, M: 6.427, S: 0.1234 },
      { age_yr: 0.5417, L: 0.8079, M: 6.969, S: 0.121 },
      { age_yr: 0.625, L: 0.7752, M: 7.443, S: 0.1192 },
      { age_yr: 0.7083, L: 0.7418, M: 7.864, S: 0.118 },
      { age_yr: 0.7917, L: 0.7083, M: 8.244, S: 0.1172 },
      { age_yr: 0.875, L: 0.675, M: 8.589, S: 0.1166 },
      { age_yr: 0.9583, L: 0.642, M: 8.909, S: 0.1163 },
      { age_yr: 1.0833, L: 0.5935, M: 9.352, S: 0.1161 },
      { age_yr: 1.25, L: 0.5307, M: 9.891, S: 0.1163 },
      { age_yr: 1.4167, L: 0.4701, M: 10.391, S: 0.1168 },
    ],
    35: [
      { age_yr: 0, L: 0.8089, M: 2.324, S: 0.1636 },
      { age_yr: 0.0027, L: 0.8128, M: 2.335, S: 0.1629 },
      { age_yr: 0.0055, L: 0.8167, M: 2.349, S: 0.1623 },
      { age_yr: 0.0082, L: 0.8204, M: 2.363, S: 0.1616 },
      { age_yr: 0.011, L: 0.824, M: 2.378, S: 0.161 },
      { age_yr: 0.0137, L: 0.8274, M: 2.394, S: 0.1603 },
      { age_yr: 0.0164, L: 0.8307, M: 2.411, S: 0.1597 },
      { age_yr: 0.0192, L: 0.8339, M: 2.43, S: 0.1591 },
      { age_yr: 0.0219, L: 0.837, M: 2.449, S: 0.1585 },
      { age_yr: 0.0246, L: 0.8399, M: 2.469, S: 0.1579 },
      { age_yr: 0.0274, L: 0.8429, M: 2.49, S: 0.1573 },
      { age_yr: 0.0301, L: 0.8456, M: 2.511, S: 0.1568 },
      { age_yr: 0.0329, L: 0.8484, M: 2.534, S: 0.1562 },
      { age_yr: 0.0356, L: 0.851, M: 2.557, S: 0.1557 },
      { age_yr: 0.0383, L: 0.8534, M: 2.58, S: 0.1551 },
      { age_yr: 0.0575, L: 0.8687, M: 2.763, S: 0.1516 },
      { age_yr: 0.0958, L: 0.8893, M: 3.181, S: 0.1454 },
      { age_yr: 0.1342, L: 0.9003, M: 3.626, S: 0.1403 },
      { age_yr: 0.1725, L: 0.9043, M: 4.065, S: 0.1359 },
      { age_yr: 0.2108, L: 0.9034, M: 4.486, S: 0.1323 },
      { age_yr: 0.2491, L: 0.8988, M: 4.883, S: 0.1291 },
      { age_yr: 0.2917, L: 0.8904, M: 5.295, S: 0.1261 },
      { age_yr: 0.375, L: 0.8675, M: 6.012, S: 0.1217 },
      { age_yr: 0.4583, L: 0.8391, M: 6.628, S: 0.1185 },
      { age_yr: 0.5417, L: 0.8079, M: 7.16, S: 0.1162 },
      { age_yr: 0.625, L: 0.7752, M: 7.626, S: 0.1146 },
      { age_yr: 0.7083, L: 0.7418, M: 8.039, S: 0.1135 },
      { age_yr: 0.7917, L: 0.7083, M: 8.411, S: 0.1128 },
      { age_yr: 0.875, L: 0.675, M: 8.751, S: 0.1123 },
      { age_yr: 0.9583, L: 0.642, M: 9.065, S: 0.1121 },
      { age_yr: 1.0833, L: 0.5935, M: 9.5, S: 0.112 },
      { age_yr: 1.25, L: 0.5307, M: 10.03, S: 0.1122 },
      { age_yr: 1.4167, L: 0.4701, M: 10.522, S: 0.1128 },
    ],
    36: [
      { age_yr: 0, L: 0.8089, M: 2.574, S: 0.1566 },
      { age_yr: 0.0027, L: 0.8128, M: 2.586, S: 0.156 },
      { age_yr: 0.0055, L: 0.8167, M: 2.599, S: 0.1554 },
      { age_yr: 0.0082, L: 0.8204, M: 2.613, S: 0.1548 },
      { age_yr: 0.011, L: 0.824, M: 2.628, S: 0.1542 },
      { age_yr: 0.0137, L: 0.8274, M: 2.644, S: 0.1536 },
      { age_yr: 0.0164, L: 0.8307, M: 2.661, S: 0.153 },
      { age_yr: 0.0192, L: 0.8339, M: 2.679, S: 0.1524 },
      { age_yr: 0.0219, L: 0.837, M: 2.698, S: 0.1519 },
      { age_yr: 0.0246, L: 0.8399, M: 2.717, S: 0.1513 },
      { age_yr: 0.0274, L: 0.8429, M: 2.738, S: 0.1508 },
      { age_yr: 0.0301, L: 0.8456, M: 2.759, S: 0.1503 },
      { age_yr: 0.0329, L: 0.8484, M: 2.782, S: 0.1497 },
      { age_yr: 0.0356, L: 0.851, M: 2.805, S: 0.1492 },
      { age_yr: 0.0383, L: 0.8534, M: 2.828, S: 0.1487 },
      { age_yr: 0.0575, L: 0.8687, M: 3.008, S: 0.1454 },
      { age_yr: 0.0958, L: 0.8893, M: 3.42, S: 0.1396 },
      { age_yr: 0.1342, L: 0.9003, M: 3.859, S: 0.1348 },
      { age_yr: 0.1725, L: 0.9043, M: 4.292, S: 0.1307 },
      { age_yr: 0.2108, L: 0.9034, M: 4.707, S: 0.1273 },
      { age_yr: 0.2491, L: 0.8988, M: 5.098, S: 0.1243 },
      { age_yr: 0.2917, L: 0.8904, M: 5.503, S: 0.1215 },
      { age_yr: 0.375, L: 0.8675, M: 6.209, S: 0.1173 },
      { age_yr: 0.4583, L: 0.8391, M: 6.814, S: 0.1144 },
      { age_yr: 0.5417, L: 0.8079, M: 7.337, S: 0.1123 },
      { age_yr: 0.625, L: 0.7752, M: 7.794, S: 0.1108 },
      { age_yr: 0.7083, L: 0.7418, M: 8.199, S: 0.1098 },
      { age_yr: 0.7917, L: 0.7083, M: 8.565, S: 0.1091 },
      { age_yr: 0.875, L: 0.675, M: 8.898, S: 0.1088 },
      { age_yr: 0.9583, L: 0.642, M: 9.206, S: 0.1086 },
      { age_yr: 1.0833, L: 0.5935, M: 9.633, S: 0.1085 },
      { age_yr: 1.25, L: 0.5307, M: 10.154, S: 0.1089 },
      { age_yr: 1.4167, L: 0.4701, M: 10.639, S: 0.1096 },
    ],
  },
};
